export default __webpack_public_path__ + "static/media/header.3ed4c7cd.png";